import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgExtendedRent = function SvgExtendedRent(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.865 1.135C10.865.508 11.373 0 12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12a1.135 1.135 0 112.27 0c0 5.374 4.356 9.73 9.73 9.73 5.374 0 9.73-4.356 9.73-9.73 0-5.374-4.356-9.73-9.73-9.73a1.135 1.135 0 01-1.135-1.135z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.155 8.591a1.135 1.135 0 01-.57-1.495A12.03 12.03 0 016.927 1.37a1.135 1.135 0 011.538.476l5.028 9.629a1.135 1.135 0 01-1.471 1.56L2.155 8.59z",
    clipRule: "evenodd"
  }));
};

export default SvgExtendedRent;